import React, { Component } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { translate, crudUpdate } from 'ra-core';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import {
	TablePagination, TextField as MuiTextField, CircularProgress, Typography, Button, useMediaQuery,
	Dialog, DialogTitle, DialogContent, DialogActions, FormControl, Select, MenuItem, InputLabel, Avatar
} from '@material-ui/core';
import { customTheme } from './customTheme';
import {
	List, Datagrid, TextField, FunctionField, DeleteButton, SimpleList,
	usePermissions, useListContext, Button as RaButton, useGetOne
} from 'react-admin';
import { MuiPickersUtilsProvider, DateTimePicker } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import moment from "moment";
import DateTimePickerToolbar from "./components/DateTimePickerToolbar";
import { vehicleSvgs } from "./sharedData";
import EditIcon from '@material-ui/icons/Edit';
import ImageDialog from "./components/ImageDialog";
import ParkingSearchSelector from "./components/ParkingSearchSelector";

const useStyles = makeStyles({
	list: {
		marginBottom: 40,
	},
	tableTitle: {
		fontSize: 22,
		fontWeight: 500,
		display: "inline-block",
	},
	timeFilterContainer: {
		alignItems: "center",
		margin: customTheme.spacing(2, 2, 3),
	},
	outlinedInput: {
		padding: 0,
	},
	timeFilterButton: {
		width: "10%",
		minWidth: 85,
	},
	searchParamsTitle: {
		fontSize: "1.05rem",
	},
	searchParams: {
		fontFamily: "Poppins-Regular",
		fontSize: "0.95rem",
	},
	parkingSelectorContainer: {
		display: "grid",
		justifyContent: "space-between",
		marginBottom: 30,
		margin: "0 16px 30px"
	},
	asyncSelector: {
		display: "grid",
		gridAutoFlow: "column",
		justifyContent: "space-between",
		paddingRight: 5,
	},
	removeMargin: {
		margin: 0,
	},
});

const renderVehicleType = (row) => (
	row.vehicle_type ?
		<div style={{ display: 'flex', alignItems: "center" }}>
			<img src={vehicleSvgs[row.vehicle_type]} style={{ width: 25, height: 25, marginRight: 8 }} alt={row.vehicle_type_label} />
			{/* row.vehicle_type_label */}
		</div>
		:
		null
);
const renderAmount = (row, fieldName) => (row[fieldName] ? `₹ ${parseFloat(row[fieldName])}` : null);
const renderDate = (row, fieldName) => (row[fieldName] ? moment(row[fieldName], "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY hh:mm a") : null);

export function VehicleDatabaseList(props) {
	const classes = useStyles();
	//const notify = useNotify();
	const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
	const { permissions } = usePermissions();
	const currentVehiclesListProps = {
		resource: "currentVehicles",
		basePath: "/currentVehicles"
	};

	const pastVehiclesListProps = {
		resource: "pastVehicles",
		basePath: "/pastVehicles"
	};

	const [startTime, setStartTime] = React.useState(null);
	const [endTime, setEndTime] = React.useState(null);
	const [startTimeFilter, setStartTimeFilter] = React.useState(null);
	const [endTimeFilter, setEndTimeFilter] = React.useState(null);

	const [page1, setPage1] = React.useState(0);
	const [rowsPerPage1, setRowsPerPage1] = React.useState(10);
	const [allZones, setAllZones] = React.useState(true);
	const [showFilter] = React.useState(sessionStorage.getItem("show_filter") === "1");
	const handleChangePage1 = (event, newPage) => {
		setPage1(newPage);
	};

	const handleChangeRowsPerPage1 = (event) => {
		setRowsPerPage1(parseInt(event.target.value, 10));
		setPage1(0);
	};

	const [page2, setPage2] = React.useState(0);
	const [rowsPerPage2, setRowsPerPage2] = React.useState(10);

	const handleChangePage2 = (event, newPage) => {
		setPage2(newPage);
	};

	const handleChangeRowsPerPage2 = (event) => {
		setRowsPerPage2(parseInt(event.target.value, 10));
		setPage2(0);
	};

	const CustomPagination = (props) => {
		const { total } = useListContext();
		const { rowsPerPage, pageNumber, handleChangePage, handleChangeRowsPerPage } = props;

		return (
			<TablePagination
				rowsPerPageOptions={isSmallDevice ? [10] : [10, 25, 50]}
				count={total ? total : 0}
				rowsPerPage={rowsPerPage}
				page={pageNumber}
				onChangePage={handleChangePage}
				onChangeRowsPerPage={handleChangeRowsPerPage}
				style={{ display: "flex", justifyContent: "flex-end", borderBottom: isSmallDevice ? 0 : undefined }}
			/>
		);
	};

	const setTimeFilter = () => {
		if (startTime)
			setStartTimeFilter(moment(startTime).format("YYYY-MM-DD HH:mm:ss"));
		if (endTime)
			setEndTimeFilter(moment(endTime).format("YYYY-MM-DD HH:mm:ss"));
	};

	const licenseNumber = useSelector(state => state.searchText);

	const parkings = useSelector(state => state.parkings);
	const [parkingId, setParkingId] = React.useState(null);
	const record = useGetOne("parkings", parkingId).data;
	const currentParking = parkings && !parkings.loading && record ? parkings.data.find(parking => parking.general_name === record.general_name) : record;
	const zoneIds = currentParking ? currentParking.zone_ids.split(",") : null;
	const zoneLabels = currentParking ? currentParking.zones.split(";") : null;
	const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
		{ id, name: zoneLabels[index] }
	)) : null;
	if (finalZones)
		finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));

	const onParkingChange = (parking) => {
		if (parking.id !== parkingId) {
			setParkingId(parking.id);
		}
	}

	const onZoneChange = (event) => {
		setParkingId(event.target.value);
	}

	return (
		<div>
			<div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0 }}>

				{showFilter && <ParkingSearchSelector
					value={record}
					onChange={onParkingChange}
					clearable={false}
				/>}

				{currentParking && currentParking.zone_ids && currentParking.zone_ids.includes(',') && <FormControl variant="outlined">
					<InputLabel>Zone Name</InputLabel>
					<Select
						value={(!record.zone_id || allZones) ? "All" : record.id}
						onChange={onZoneChange}
						label="Zone Name"
						variant="outlined"
						renderValue={(value) => <div className={classes.asyncSelector}><span>{(!record.zone_id || allZones) ? "All" : record.name}</span>{parkings.loading && <CircularProgress size={20} />}</div>}
						disabled={!record.zone_id}
					>
						<MenuItem value="All" onClick={() => setAllZones(true)}>All</MenuItem>
						{finalZones.map((zone, index) => (
							<MenuItem key={index} value={zone.id} onClick={() => setAllZones(false)}>{zone.name}</MenuItem>
						))}
					</Select>
				</FormControl>}
			</div>

			{parkingId != null && <>
				<MuiPickersUtilsProvider utils={DateFnsUtils}>
					<div className={classes.timeFilterContainer} style={{ display: isSmallDevice ? "grid" : "flex", gridRowGap: isSmallDevice ? 12 : 0 }}>
						<Typography>Search</Typography>
						<div style={{ flexBasis: "100%" }}>
							<DateTimePicker
								disableFuture
								ampm
								value={startTime}
								onChange={(time) => setStartTime(time)}
								label="From Time"
								style={{ marginLeft: isSmallDevice ? 0 : "2%" }}
								inputVariant="outlined"
								TextFieldComponent={(props) => <MuiTextField {...props} size="small" />}
								ToolbarComponent={DateTimePickerToolbar}
								format="dd/MM/yyyy hh:mm a"
							/>
							<DateTimePicker
								disableFuture
								ampm
								value={endTime}
								onChange={(time) => setEndTime(time)}
								label="To Time"
								style={{ marginLeft: isSmallDevice ? 0 : "2%", display: isSmallDevice ? "block" : "inline-flex", marginTop: isSmallDevice ? 14 : 0 }}
								inputVariant="outlined"
								TextFieldComponent={(props) => <MuiTextField {...props} size="small" />}
								ToolbarComponent={DateTimePickerToolbar}
								format="dd/MM/yyyy hh:mm a"
							/>
						</div>
						<Button variant="contained" className={classes.timeFilterButton} color="primary" onClick={setTimeFilter} style={{ marginLeft: isSmallDevice ? 0 : "1%" }}>Search</Button>
					</div>
				</MuiPickersUtilsProvider>
				<div style={{ margin: "0 16px 35px" }}>
					<Typography className={classes.searchParamsTitle}>Showing Results for</Typography>
					{!!licenseNumber && licenseNumber !== "" && <Typography className={classes.searchParams}>License number: {licenseNumber}</Typography>}
					<Typography className={classes.searchParams}>Time Period: {startTimeFilter ? moment(startTimeFilter).format("MMM Do, YYYY hh:mm a") : "Start"} — {endTimeFilter ? moment(endTimeFilter).format("MMM Do, YYYY hh:mm a") : "End"}</Typography>
				</div>

				<div className={classes.list}>
					<Typography className={classes.tableTitle} style={{ margin: isSmallDevice ? "0 16px 8px" : "0 0 8px", fontSize: isSmallDevice ? 20 : 22 }}>Currently Parked</Typography>

					<List
						title="List of Current Vehicles"
						bulkActionButtons={false}
						filter={{ access_key: parkingId, startTime: startTimeFilter, endTime: endTimeFilter, licenseNumber: licenseNumber, page: page1, perPage: rowsPerPage1, zone_id: allZones && record ? record.zone_id : null }}
						sort={{ field: 'entry_time', order: 'DESC' }}
						pagination={<CustomPagination rowsPerPage={rowsPerPage1} pageNumber={page1} handleChangePage={handleChangePage1} handleChangeRowsPerPage={handleChangeRowsPerPage1} />}
						actions={null}
						resource="currentVehicles"
						basePath="/currentVehicles"
						hasList={true}
						hasShow={false}
						hasEdit={false}
						hasCreate={false}
					>
						{isSmallDevice ?
							<SimpleList
								leftIcon={row => <Avatar alt={row.vehicle_type_label} src={vehicleSvgs[row.vehicle_type]} style={{ padding: 4, width: 28, height: 28, marginTop: 8, marginRight: 10, overflow:"visible" }} />}
								primaryText={record => record.license_number}
								secondaryText={record => <div>
									<div>Entry: {renderDate(record, "entry_time")}{currentParking && currentParking.show_amount_in_crm === 1 && record.amount_at_entry ? ` — ₹ ${parseFloat(record.amount_at_entry)}` : ""}</div>
									<div>Entry User ID: {record.entry_user_id}</div>
									<div>Day Pass: {record.day_pass === 1 ? "Yes" : "No"}</div>
									<div style={{ display: "flex", rowGap: 10 }}>
										{(permissions === 'admin' || permissions === 'sales') && <DeleteButton {...currentVehiclesListProps} record={record} mutationMode="optimistic" redirect="/vehicleDatabase" />}
									</div>
								</div>}
								linkType={false}
								rowStyle={() => ({ alignItems: "flex-start" })}
							/>
							:
							<Datagrid>
								<TextField source="license_number" sortable={false} />
								<FunctionField
									label="Entry Time"
									render={(record) => renderDate(record, "entry_time")}
								/>
								<FunctionField
									label="Vehicle Type"
									render={renderVehicleType}
								/>
								{currentParking && currentParking.show_amount_in_crm === 1 && <FunctionField
									label="Amount at entry"
									render={(record) => renderAmount(record, "amount_at_entry")}
								/>}
								<TextField label="Entry User ID" source="entry_user_id" sortable={false} />
								<ImageDialog label="Vehicle Image" source="vehicle_image_url" sortable={false} />
								<FunctionField label="Day Pass" render={row => row.day_pass === 1 ? "Yes" : "No"} />
								{(permissions === 'admin' || permissions === 'sales') && <DeleteButton mutationMode="optimistic" redirect="/vehicleDatabase" />}
							</Datagrid>
						}
					</List>
				</div>

				<div className={classes.list}>
					<Typography className={classes.tableTitle} style={{ margin: isSmallDevice ? "0 16px 8px" : "0 0 8px", fontSize: isSmallDevice ? 20 : 22 }}>History</Typography>

					<List
						title="List of past vehicles"
						bulkActionButtons={false}
						filter={{ access_key: parkingId, startTime: startTimeFilter, endTime: endTimeFilter, license_number: licenseNumber, page: page2, perPage: rowsPerPage2, zone_id: allZones && record ? record.zone_id : null }}
						sort={{ field: 'exit_time', order: 'DESC' }}
						pagination={<CustomPagination rowsPerPage={rowsPerPage2} pageNumber={page2} handleChangePage={handleChangePage2} handleChangeRowsPerPage={handleChangeRowsPerPage2} />}
						actions={null}
						hasList={true}
						hasShow={false}
						hasEdit={false}
						hasCreate={false}
						{...pastVehiclesListProps}
					>
						{isSmallDevice ?
							<SimpleList
								leftIcon={row => <Avatar alt={row.vehicle_type_label} src={vehicleSvgs[row.vehicle_type]} style={{ padding: 4, width: 28, height: 28, marginTop: 8, marginRight: 10, overflow:"visible" }} />}
								primaryText={record => record.license_number}
								secondaryText={record => <div>
									<div>Entry: {renderDate(record, "entry_time")}{currentParking && currentParking.show_amount_in_crm === 1 && record.amount_at_entry ? ` — ₹ ${parseFloat(record.amount_at_entry)}` : ""}</div>
									<div>Exit: {renderDate(record, "exit_time")}{currentParking && currentParking.show_amount_in_crm === 1 && record.amount_at_exit ? ` — ₹ ${parseFloat(record.amount_at_exit)}` : ""}</div>
									<div>Total Duration: {record.total_duration}</div>
									<div>Entry User ID: {record.entry_user_id}</div>
									<div>Exit User ID: {record.exit_user_id}</div>
									{record.remarks && record.remarks.trim() !== "" && <div>Remarks: {record.remarks}</div>}
									<div>Day Pass: {record.day_pass === 1 ? "Yes" : "No"}</div>
									<div style={{ display: "flex", rowGap: 10 }}>
										{(permissions === 'admin' || permissions === 'sales') && <CustomEditButton {...pastVehiclesListProps} record={record} />}
										{(permissions === 'admin' || permissions === 'sales') && <DeleteButton {...pastVehiclesListProps} record={record} mutationMode="optimistic" redirect="/vehicleDatabase" />}
									</div>
								</div>}
								linkType={false}
								rowStyle={() => ({ alignItems: "flex-start" })}
							/>
							:
							<Datagrid>
								<TextField source="license_number" sortable={false} />
								<FunctionField
									label="Entry Time"
									render={(record) => renderDate(record, "entry_time")}
								/>
								<FunctionField
									label="Exit Time"
									render={(record) => renderDate(record, "exit_time")}
								/>
								<TextField source="total_duration" sortable={false} />
								<FunctionField
									label="Vehicle Type"
									render={renderVehicleType}
								/>
								<TextField source="note" sortable={false} />
								{currentParking && currentParking.show_amount_in_crm === 1 && <FunctionField
									label="Amount at entry"
									render={(record) => renderAmount(record, "amount_at_entry")}
								/>}
								{currentParking && currentParking.show_amount_in_crm === 1 && <FunctionField
									label="Amount at exit"
									render={(record) => renderAmount(record, "amount_at_exit")}
								/>}
								<TextField label="Entry User ID" source="entry_user_id" sortable={false} />
								<TextField label="Exit User ID" source="exit_user_id" sortable={false} />
								<ImageDialog label="Vehicle Image" source="vehicle_image_url" sortable={false} />
								<FunctionField label="Day Pass" render={row => row.day_pass === 1 ? "Yes" : "No"} />
								{(permissions === 'admin' || permissions === 'sales') && <CustomEditButton />}
								{(permissions === 'admin' || permissions === 'sales') && <DeleteButton mutationMode="pessimistic" redirect="/vehicleDatabase" />}
							</Datagrid>
						}
					</List>
				</div>
			</>}
		</div>
	);
};

class EditButton extends Component {
	state = {
		showDialog: false,
		license_number: this.props.record.license_number,
		license_number_error: false,
		entry_time: moment(this.props.record.entry_time, "YYYY-MM-DD HH:mm:ss").toDate(),
		exit_time: moment(this.props.record.exit_time, "YYYY-MM-DD HH:mm:ss").toDate(),
	};

	handleClick = () => {
		this.setState({
			showDialog: true,
			license_number: this.props.record.license_number,
			license_number_error: false,
			entry_time: moment(this.props.record.entry_time, "YYYY-MM-DD HH:mm:ss").toDate(),
			exit_time: moment(this.props.record.exit_time, "YYYY-MM-DD HH:mm:ss").toDate(),
		});
	};

	handleCloseClick = () => {
		this.setState({ showDialog: false });
	};

	handleUpdate = (event) => {
		event.preventDefault();
		//if(!new RegExp("[A-z0-9]+").test(this.state.license_number)) {
		if (this.state.license_number.length === 0) {
			this.setState({ license_number_error: true });
			return;
		}
		this.setState({ showDialog: false });
		const { license_number, entry_time, exit_time } = this.state;
		const { dispatchCrudUpdate, resource, record, basePath } = this.props;
		const data = {
			newData: {
				license_number,
				entry_time: moment(entry_time).format("YYYY-MM-DD HH:mm:ss"),
				exit_time: moment(exit_time).format("YYYY-MM-DD HH:mm:ss"),
			},
			oldData: record,
		};
		dispatchCrudUpdate(resource, record.id, data, record, basePath, "/vehicleDatabase");
	};

	render() {
		const { showDialog, license_number, license_number_error, entry_time, exit_time } = this.state;
		const { label = 'ra.action.edit' } = this.props;
		return (
			<>
				<RaButton onClick={this.handleClick} label={label}>
					<EditIcon />
				</RaButton>

				<MuiPickersUtilsProvider utils={DateFnsUtils}>
					<Dialog fullWidth open={showDialog} onClose={this.handleCloseClick}>
						<DialogTitle>Edit Record</DialogTitle>
						<DialogContent style={{ display: "grid", gridRowGap: 20 }}>
							<MuiTextField
								variant="outlined"
								size="small"
								label="License Number"
								value={license_number}
								onChange={(event) => this.setState({ license_number: event.target.value, license_number_error: false })}
								error={license_number_error}
								maxLength={200}
							/>
							<DateTimePicker
								disableFuture
								ampm
								value={entry_time}
								onChange={(time) => this.setState({ entry_time: time })}
								label="Entry Time"
								inputVariant="outlined"
								TextFieldComponent={(props) => <MuiTextField {...props} size="small" />}
								ToolbarComponent={DateTimePickerToolbar}
								format="dd/MM/yyyy hh:mm a"
							/>
							<DateTimePicker
								disableFuture
								ampm
								value={exit_time}
								onChange={(time) => this.setState({ exit_time: time })}
								label="Exit Time"
								inputVariant="outlined"
								TextFieldComponent={(props) => <MuiTextField {...props} size="small" />}
								ToolbarComponent={DateTimePickerToolbar}
								format="dd/MM/yyyy hh:mm a"
							/>
						</DialogContent>
						<DialogActions>
							<Button color="primary" onClick={this.handleUpdate}>Save</Button>
							<Button color="primary" onClick={this.handleCloseClick}>Cancel</Button>
						</DialogActions>
					</Dialog>
				</MuiPickersUtilsProvider>
			</>
		);
	}
}

EditButton.defaultProps = {
	redirect: 'list',
	undoable: false
};

const CustomEditButton = compose(
	connect(
		null,
		{ dispatchCrudUpdate: crudUpdate }
	),
	translate
)(EditButton);
